{
  "errors": {
    "productInitialFetchError": "Fetching product or product related data failed",
    "dependencyDataError": "The system doesn't seem to have any locales or categories. Products can be added only after there is at least one locale and one category in the system.",
    "materialCodeSave": "Updating material code failed",
    "acquisitionPriceSave": "Updating acquisition prices failed"
  },
  "populatescreen": {
    "prepopulate_product_title": "Add New Product",
    "steps_title": "Steps",
    "product_type_step": "Product type",
    "fetch_data_step": "Fetch data",
    "languages_step": "Languages",
    "variants_step": "Variants",
    "product_type_title": "Select product type",
    "product_type_info": "Products will be displayed and treated differently in the system based on their type. This selection also helps product managers to identify products.",
    "product_type_hardware": "Hardware",
    "product_type_hardware_info": "(products that have stock levels)",
    "product_type_service": "Service",
    "product_type_service_info": "(products that don’t have stock levels)",
    "manufacturer_and_sku_title": "Manufacturer and SKU",
    "manufacturer_and_sku_info": "Start by entering brand name and product SKU. We can populate the product info from C|NET if available. ",
    "brand_label": "Brand",
    "sku_label": "SKU",
    "prepopulate_failed_product_not_found_info": "Product was not found from C|NET",
    "prepopulate_failed_timeout_info": "Getting product data from C|NET timed out",
    "prepopulate_failed_general_info": "Something went wrong when trying to get product data from C|NET",
    "manual_entry_question": "Would you like to manually create the product?",
    "product_not_found_try_prepopulate_again": "Update manufacturer or SKU and try populate again",
    "general_try_prepopulate_again": "Try populate again",
    "found_match": "We found a match!",
    "not_what_you_need_question": "Not what you need?",
    "product_image_alt": "Product image",
    "languages_title": "Languages",
    "languages_info": "By default, all languages ({{languages}}) should be added to PIMS at the same time. Editor who adds the first entry should make sure the copy is proofread by native speakers.",
    "variants_title": "Variants",
    "variants_info": "Variants let you organise a group of products that share same specs and descriptions under one page. For example, iPhone 12 is a product line that comes with different colors and storage size options. Now you can create just one product to PIMS called iPhone 12.",
    "variants_use": "Use variants",
    "variants_yes": "Yes",
    "variants_no": "No",
    "buttons": {
      "next": "Next",
      "manual_entry": "Start manual entry",
      "try_populate_again": "Try populate again",
      "use_this": "Use this"
    }
  },
  "editscreen": {
    "add_product_title": "Add New Product",
    "update_product_title": "Update Product",
    "buttons": {
      "save_changes": "Save changes"
    },
    "confirm_unsaved_changes": "You have unsaved changes. Are you sure you want to leave the form?",
    "translation": "Translation",
    "reference": "Reference",
    "reference_english": "English",
    "sections": "Sections",
    "section_has_errors_tooltip": "This section has errors. Fix them before saving changes.",
    "common_product_section_titles": {
      "discoverability": "Discoverability",
      "images": "Images",
      "key_selling_points": "Key Selling Points",
      "long_description": "Long Description",
      "specs": "Specs",
      "box_contents": "Box Contents",
      "videos": "Videos"
    },
    "product_section_titles_without_variants": {
      "basic_data": "Basic Data"
    },
    "product_section_titles_with_variants": {
      "group_name": "Group Name",
      "tfProductId": "Product ID in Telia Finance",
      "variants_detail": "Variants Detail"
    },
    "errors": {
      "name_blank": "Name must not be blank",
      "brand_blank": "Brand must not be blank",
      "sku_blank": "SKU must not be blank",
      "sku_duplicate": "There can't be multiple variants with same SKU",
      "property_value_empty": "Property value must not be empty",
      "variant_duplicate": "There can't be multiple variants with same property values combination",
      "category_empty": "Category must not be empty",
      "box_contents_none": "There must be at least one box content",
      "box_content_blank": "Box content must not be blank",
      "key_selling_points_none": "There must be at least one key selling point",
      "key_selling_point_blank": "Key selling point must not be blank",
      "description_blank": "Description must not be blank",
      "description_translation_blank": "Translation ({{languages}}) for description must not be blank",
      "spec_label_blank": "Spec label must not be blank",
      "spec_no_lines": "Spec must have at least one line",
      "spec_line_blank": "Spec line must not be blank",
      "some_videos_blank": "Video URLs for languages ({{languages}}) must not be blank",
      "some_videos_invalid_url": "Video URLs for languages ({{languages}}) must be valid",
      "validation": "Some sections contain invalid data. Fix these before saving changes.",
      "create_product": "Error occurred while creating product",
      "update_product": "Error occurred while updating product"
    }
  },
  "basic_data_section": {
    "info": "Displayed as page header. Do not include variant details here.",
    "name_reference_label": "Product name reference",
    "name_reference_placeholder": "Product name reference",
    "name_translation_label": "Product name translation",
    "name_translation_placeholder": "{{language}} translation",
    "sku_label": "SKU",
    "sku_placeholder": "sku",
    "brand_label": "Brand",
    "brand_placeholder": "Brand",
    "product_type_hardware": "Hardware",
    "product_type_hardware_info": "(products that have stock levels)",
    "product_type_service": "Service",
    "product_type_service_info": "(products that don’t have stock levels)"
  },
  "group_name_section": {
    "info": "The group name should not contain any variant details, e.g. iPhone 11 Pro Max.",
    "group_name_reference_label": "Group name reference",
    "group_reference_placeholder": "Group name reference",
    "group_name_translation_label": "Group name translation",
    "group_translation_placeholder": "{{language}} translation",
    "brand_label": "Brand",
    "brand_placeholder": "Brand",
    "product_type_hardware": "Hardware",
    "product_type_hardware_info": "(products that have stock levels)",
    "product_type_service": "Service",
    "product_type_service_info": "(products that don’t have stock levels)"
  },
  "variants_detail_section": {
    "info": "Input product SKU, attributes (e.g. color), and manage which sales channels is the product available in.",
    "selected_variants_count_one": "Selected {{count}} variant",
    "selected_variants_count_other": "Selected {{count}} variants",
    "cant_delete_all_variants_tooltip": "Can't delete all variants of product. At least one variant needs to be left.",
    "overflow_menu_edit_variant_types": "Edit variant types",
    "overflow_manu_reset_variant_types": "Reset to default",
    "add_new_variant": "Add new variant",
    "sku_table_header": "SKU",
    "property_value_dropdown_placeholder": "Value",
    "variant_types_modal_title": "Variant types",
    "variant_types_modal_info": "This setting only affects current product group.",
    "variant_types_variant_type_table_header": "Variant type",
    "variant_types_modal_add_variant_type": "Add line",
    "add_variant_type_dropdown_label": "Add new variant type applicable to product group",
    "add_variant_type_dropdown_placeholder": "Choose new variant type",
    "add_variant_type_dropdown_placeholder_all_properties_added": "All properties of the system already added",
    "delete_variant_type": "Delete variant type applicable to product",
    "buttons": {
      "delete_variants": "Delete",
      "add_variant_type": "Add new variant type"
    },
    "fetch_and_add_images": "Fetch images",
    "add_images_info": "Fetch and add images of this product variant from CNET. Images are fetched based on brand and SKU.",
    "add_images_disabled_info": "You must add at least one variant type (e.g. Color) that is applicable to the variants of this product before images can be added.",
    "add_images_no_property_values_error": "No variant values set",
    "add_images_no_property_values_error_info": "At least one variant value must be set for a variant before images of variant can be added. The images will be set to be applicable to the variant values you have selected for this variant.",
    "variant_images_add_success": "Variant images fetched and added succesfully to this product. You can see the new images in the Images section",
    "variant_images_add_error": "Adding variant images failed. Make sure the product brand and variant SKU are valid.",
    "variant_images_add_empty": "Found no images or new images for variant."
  },
  "discoverability_section": {
    "info": "Choose category, sub catagory and add tags to make the products easier to find.",
    "category_label": "Category",
    "category_placeholder": "Category",
    "sub_category_label": "Sub category",
    "sub_category_placeholder": "Sub category",
    "tags_label": "Tags",
    "tag_placeholder": "Add new tag",
    "remove_tag": "Remove tag"
  },
  "images_section": {
    "info": "Upload product images.",
    "product_image_alt": "Product image",
    "image_name_placeholder": "Product image from CNET",
    "image_applicable_to_all": "All",
    "upload_image": "Upload image",
    "delete_image": "Delete image"
  },
  "key_sellingpoints_section": {
    "info": "Up to 5 key selling points, displayed next to product image carousel.",
    "point_reference_label": "Point {{index}} reference",
    "point_reference_placeholder": "Key selling point reference",
    "point_translation_label": "Point {{index}}",
    "point_translation_placeholder": "{{language}} translation",
    "add_key_sellingpoint": "Add key selling point",
    "delete_key_selling_point": "Delete key selling point"
  },
  "long_description_section": {
    "info": "Long description is the main copytext of the product.",
    "description_reference_label": "Description reference",
    "description_reference_placeholder": "Description reference",
    "description_translation_label": "Description translation",
    "description_translation_placeholder": "{{language}} translation"
  },
  "specs_section": {
    "info": "Detailed specs for the product(s).",
    "spec_name_reference_label": "Label reference",
    "spec_name_reference_placeholder": "Label reference",
    "spec_name_translation_label": "Label",
    "spec_name_translation_placeholder": "{{language}} translation",
    "spec_line_reference_label": "Line {{index}} reference",
    "spec_line_reference_placeholder": "Line reference",
    "spec_line_translation_label": "Line {{index}}",
    "spec_line_translation_placeholder": "{{language}} translation",
    "delete_spec": "Delete spec",
    "add_spec": "Add spec",
    "add_line": "Add line",
    "delete_line": "Delete line"
  },
  "box_contents_section": {
    "info": "What’s in the product package?",
    "item_reference_label": "Item {{index}} reference",
    "item_reference_placeholder": "Item reference",
    "item_translation_label": "Item {{index}}",
    "item_translation_placeholder": "{{language}} translation",
    "add_box_content": "Add item",
    "delete_box_content": "Delete item"
  },
  "videos_section": {
    "info": "Input YouTube or Vimeo video links line by line. Each video is specific to a single translation.",
    "video_label": "{{language}} video {{index}}",
    "video_placeholder": "URL for {{language}} video",
    "add_video": "Add video",
    "delete_video": "Delete video"
  },
  "mainScreen": {
    "subheaderText": "Product",
    "partiallyAvailableBadge": "Partially available for sale",
    "availableBadge": "Available for sale",
    "altFlagIcon": "Flag icon"
  },
  "productInformationCard": {
    "title": "Product information",
    "productType": "Product type",
    "hardware": "Hardware",
    "service": "Service",
    "editButton": "Edit product information"
  },
  "materialCodes": {
    "title": "Material codes",
    "infoText": "Configure material codes for each variant.",
    "noMaterialCodes": "No material codes",
    "missingCode": "Missing code",
    "updateRequired": "Update required",
    "sku": "SKU",
    "product": "Product",
    "variant": "Variant",
    "country": "Country",
    "materialCode": "Material code",
    "editButton": "Edit",
    "duplicateCodes": "Duplicate codes",
    "copy": "Copy",
    "copyMessage": "Copied to clipboard"
  },
  "materialCodeEditModal": {
    "heading": "Edit material code",
    "materialCodeInputLabel": "Material code (COLT Product code)",
    "saveChanges": "Save changes",
    "cancel": "Cancel",
    "paragraph1": "Material code is a reference number for the device in the warehouse inventory system.",
    "paragraph2": "Link to inventory system used in Finland: <a>COLT ></a",
    "paragraph3": "In COLT, the material code is called <strong>Product code</strong>.",
    "missingMaterialCodeError": "Could not find matching code from COLT. Add code manually."
  },
  "productPricingCard": {
    "title": "Pricing",
    "updateRequired": "Update required",
    "priceFetchedFromPriceMaster": "Price is automatically fetched and periodically refreshed from PriceMaster with material code. If pricing seems out of date, try refreshing product data.",
    "refreshProductDataButton": "Refresh product data",
    "useSameSettingsForAllVariants": "Use same settings for all variants",
    "financeAcquisitionPrice": "Finance acquisition price, excl. VAT",
    "missingFinanceAcquisitionPrice": "Missing price",
    "missingMaterialCode": "Missing material code",
    "financeMonthlyPrice": "Finance monthly price",
    "financeMonthlyPriceInfo": "Price defined in sales channel settings",
    "editButton": "Edit pricing"
  },
  "pricingEditModal": {
    "heading": "Edit product pricing",
    "saveChanges": "Save changes",
    "cancel": "Cancel",
    "productTitle": "Product",
    "copy": "Copy",
    "copyMessage": "Copied to clipboard",
    "financeAcquisitionPriceInputLabel": "Finance acquisition price, excl. VAT ({{currency}})",
    "missingFinanceAcquisitionPriceError": "Missing price",
    "financeMonthlyPriceLabel": "Finance monthly price ({{currency}})",
    "financeMonthlyPriceValueInfo": "Price set for bundles in sales channel settings"
  },
  "tfProductIdSection": {
    "country": "Country",
    "financeProductName": "Finance product name",
    "financeProductId": "Finance product ID",
    "title": "Product ID in Telia Finance",
    "guideText": "Needed by Telia Finance to get prices for this product.",
    "errorGettingFinanceProductList": "Error getting Finance product options list",
    "clearCountryFinanceProductId": "Clear Finance product ID"
  }
}
